import * as React from "react";
import * as ReactDOM from "react-dom";
import * as moment from "moment";
import * as modelsGet from "../../models/get";
import * as modelsCalendar from "../../models/calendar";
import { isEventFullyVisible, getLockPosition } from "../../utils/calendar";
import { lighten, darken } from "../../utils/color";
import { OptionalLink } from "../optionalLink";

interface IProperties
{
    /**
     * Wenn angegeben, wird hiermit das zugrunde liegende DOM-Element ermittelt.
     */
    appointmentRef?: (ref: HTMLAnchorElement) => void,

    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Der momentan selektierte Kalender.
     * Dieser Wert ist immer gefüllt auch wenn keine KalenderGruppe ausgewählt ist. Wenn keine
     * Gruppe ausgewählt ist, beinhaltet diese Eigenschaft den Kalender aus SelectedObject.
     */
    currentSelectedCalendar: modelsGet.ICalendar,

    /**
     * Der Termin der gerendert werden soll.
     */
    appointment?: modelsGet.IAppointment,

    /**
     * Angabe, ob der Termin für die Monatsansicht gerendert werden soll.
     */
    isForMonthView: boolean,

    /**
     * Angabe, ob der Betreff fettgedruckt ist.
     */
    isSubjectBold?: boolean,

    /**
     * Angabe, ob der Termin gesperrt ist.
     */
    isDisabled?: boolean,

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (appointment: modelsGet.IAppointment) => void
}

export class BlockedAppointment extends React.Component<IProperties>
{
    /**
     * Standardwerte setzen.
     */
    public static defaultProps: Partial<IProperties> = {
        isSubjectBold: false,
        isDisabled: false
    };

    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        var { appointment, onClick } = this.props;
        onClick && onClick(appointment);
    }

    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        var {
            appointmentRef,
            style,
            currentSelectedCalendar,
            appointment,
            isForMonthView,
            isSubjectBold,
            isDisabled
        } = this.props;

        if (appointment != null)
        {
            // CSS-Klasse generieren.
            var classNames: string[] = ["event"]

            if (isForMonthView)
                classNames.push("event--monthv");
            else
                classNames.push("event--dayv");

            classNames.push("event--is-locked");

            // Styles generieren.
            let baseStyle: React.CSSProperties = {
                opacity: (isEventFullyVisible(appointment, currentSelectedCalendar.id) ? 1 : 0.4),
                ...style
            };

            // Position der Sperre ermitteln.
            if (!isForMonthView)
            {
                let lockPosition = getLockPosition(appointment);
                baseStyle.top = lockPosition.top;
                baseStyle.height = lockPosition.height;
                baseStyle.padding = lockPosition.padding;
            }

            let linkTo: Object = {
                pathname: `/lock/${appointment.id}${appointment.repeat_until ? "?series=true" : ""}`,
                state: {
                    modal: true
                }
            };
            
            if (isDisabled)
                linkTo = null;

            return (
                <OptionalLink
                    anchorRef={appointmentRef}
                    className={classNames.join(" ")}
                    style={baseStyle}
                    onClick={this.onClick}
                    to={linkTo}>
                    <div className="event_border"></div>
                    <div className="event_content">
                        <div className="event_content_subject">
                            <div className="event_content_subject_time">{moment(appointment.starttime).format("HH:mm")}</div>
                            <div className={`event_content_subject_text ${isSubjectBold ? "event_content_subject--is-bold" : ""}`}>{appointment.calendar_name + ", " + appointment.description}</div>
                        </div>
                    </div>
                </OptionalLink>
            );
        }
        else
        {
            return null;
        }
    }
}